import { render, staticRenderFns } from "./vue-tinymce-wrap.vue?vue&type=template&id=16722e5a&scoped=true&"
import script from "./vue-tinymce-wrap.vue?vue&type=script&lang=js&"
export * from "./vue-tinymce-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16722e5a",
  null
  
)

export default component.exports